// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7WLPq","schoolName":"Footer_schoolName__BzI0a","footerContainer":"Footer_footerContainer__CKQhp","phoneIcon":"Footer_phoneIcon__ompZM"};